import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CorporateAdmin() {
  const [form, setForm] = useState({ title: '', content: '', image: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCorporate = async () => {
      try {
        const { data } = await axios.get(`${API}/api/public/corporate`, { withCredentials: true });
        if (data) setForm(data);
      } catch (err) {
        toast.error('Kurumsal bilgisi yüklenemedi');
      }
    };
    fetchCorporate();
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await axios.post(`${API}/api/upload`, formData, { withCredentials: true });
      setForm({ ...form, image: data.url });
      toast.success('Görsel yüklendi');
    } catch (err) { toast.error('Yükleme başarısız'); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${API}/api/admin/corporate`, form, { withCredentials: true });
      toast.success('Kurumsal bilgisi güncellendi');
    } catch (err) {
      toast.error('Kurumsal güncellenemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <h1 className="text-2xl font-bold text-slate-900">Kurumsal / Hakkımızda Yönetimi</h1>
      
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Başlık</label>
          <input type="text" value={form.title || ''} onChange={e => setForm({...form, title: e.target.value})} className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">İçerik (Paragraflar halinde)</label>
          <textarea value={form.content || ''} onChange={e => setForm({...form, content: e.target.value})} rows={15} className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-primary outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Görsel</label>
          {form.image && <img src={form.image.startsWith('http') ? form.image : API + form.image} alt="Preview" className="h-48 w-full object-cover rounded-xl mb-4" />}
          <label className="cursor-pointer bg-slate-100 text-slate-600 px-4 py-3 rounded-xl inline-flex items-center justify-center gap-2 hover:bg-slate-200 transition-colors text-sm font-medium">
            Görsel Yükle / Değiştir
            <input type="file" className="hidden" accept="image/*" onChange={handleUpload} />
          </label>
        </div>
        
        <div className="pt-4 border-t border-slate-100">
          <button type="submit" disabled={loading} className="bg-primary text-white px-8 py-3 rounded-xl font-medium hover:bg-primary/90 transition-colors">
            {loading ? 'Kaydediliyor...' : 'Değişiklikleri Kaydet'}
          </button>
        </div>
      </form>
    </div>
  );
}
